<script>
export default {
    name: "confirm-dialog-body",
    props: {
        message: {
            type: String
        },
        confirmMsg: {
            type: String
        },
        showTextIcon: {
            type: Boolean,
            default: false
        },
        textIconType: {
            Type: String,
            default: 'fal fa-triangle-exclamation'
        }
    },
}
</script>

<template>
    <div class="ma-4 confirm-dialog d-flex flex-row">
        <div v-if="showTextIcon" class="confirm-dialog-icon">
            <v-icon color="black">{{ textIconType }}</v-icon>
        </div>
        <div class="d-flex flex-column justify-center" >
            <div class="confirm-text">{{message}}</div>
            <div v-if="confirmMsg" class="confirm-additional-text confirm-text">{{confirmMsg}}</div>
        </div>
    </div>
</template>

<style scoped>
    .confirm-dialog {
        font-size: 16px;
        margin: 26px 16px 10px 18px!important;
    }

    .confirm-dialog-icon {
        margin-right: 20px;

        .v-icon.v-icon {
            font-size: 3rem;
        }
    }
    .confirm-text {
        white-space: pre-wrap;
    }

    .confirm-additional-text {
        font-weight: 700;
        font-size: 15px;
        margin: 16px 18px 0 0;
    }
</style>
